import api from "./api";
import ApiResponse from "src/interfaces/ApiResponse";
import { EmpresaDto } from "src/pages/Privada/Entidade/Empresa/Empresa.Dto";
import {
  PessoaDto,
  PessoaFiltrarDto,
} from "src/pages/Privada/Entidade/Pessoa/Pessoa.Dto";
import { PessoaCadastroConsultaDto } from "src/pages/Privada/Entidade/Pessoa/Cadastro/PessoaCadastro.Dto";
import { CertificadoInluirInputDto } from "src/pages/Privada/Entidade/Certificado/Certificado.Dto";

export function MunicipioBuscarPorNome(nome: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE +
      "/municipio/buscar-por-nome?nome=" +
      nome
  );
}

export function EmpresaIncluir(input: EmpresaDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE + "/empresa/incluir",
    input
  );
}

export function EmpresaBuscarPorUsuario() {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE + "/empresa/buscar-por-usuario"
  );
}

export function EmpresaAtualizar(input: EmpresaDto) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE + "/empresa/atualizar",
    input
  );
}

export async function PessoaFiltrar(input: PessoaFiltrarDto) {
  return await api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE + "/pessoa/filtrar",
    {
      params: input,
    }
  );
}

export function PessoaBuscarPorId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE +
      "/pessoa/buscar-por-id?id=" +
      id
  );
}

export function PessoaIncluir(input: PessoaDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE + "/pessoa/incluir",
    input
  );
}

export function PessoaAtualizar(input: PessoaDto) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE + "/pessoa/atualizar",
    input
  );
}

export function CertificadoBuscarInfo() {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE +
      "/certificado/buscar-certificado-info"
  );
}

export function CertificadoIncluir(input: CertificadoInluirInputDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE + "/certificado/incluir",
    input
  );
}

export function CertificadoAtualizar(input: CertificadoInluirInputDto) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE + "/certificado/atualizar",
    input
  );
}

export function PessoaConsultaCadastro(input: PessoaCadastroConsultaDto) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ENTIDADE + "/pessoa/consulta-cadastro",
    {
      params: input,
    }
  );
}
